import { makeStyles } from '@material-ui/styles'

export default makeStyles(_ => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  govBrContainer: {
    maxWidth: '50vw',
  },
  warningGovBrContainer: {
    backgroundColor: '#eee',
    padding: 10,
    gap: 8,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
  },
}))
